import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectAttachmentPreferencesOption')(function selectAttachmentPreferencesOption(optionKey, preference, state) {
    var optionState = state.optionState;
    optionState[optionKey] = preference;
}));
//# sourceMappingURL=selectAttachmentPreferencesOption.js.map